import { Link } from 'react-router-dom';

const CALENDLY = 'https://calendly.com/jagan-motionx/30min';

export default function FooterCTA() {
  return (
    <footer className="bg-black border-t border-white/[0.08] w-full">
      {/* Editorial Closing Statement */}
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24 py-24 sm:py-32 border-b border-white/[0.08]">
        <div className="max-w-3xl">
          <p className="text-[11px] font-mono uppercase tracking-[0.14em] text-[#E50914] mb-3">
            ● Start a Production
          </p>
          <h2 className="text-white font-normal tracking-[-0.035em] leading-[1.02] text-[clamp(2.2rem,4.5vw,4.25rem)]">
            Bring your next commercial, micro-drama, or feature sequence to life.
          </h2>
          <div className="flex flex-wrap items-center gap-3 mt-8">
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#E50914] text-white hover:bg-[#ff1a25] shadow-[0_0_28px_rgba(229,9,20,0.35)] px-6 py-3 rounded-full text-[13px] font-medium tracking-[-0.01em] transition-all no-underline"
            >
              Book a Creative Call
            </a>
            <Link
              to="/case-studies/stadium-vfx"
              className="bg-white/[0.06] hover:bg-white/[0.12] border border-white/15 text-white px-5 py-3 rounded-full text-[13px] transition-all no-underline"
            >
              Read Stadium VFX Case Study →
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Footer Links */}
      <div className="w-full px-5 sm:px-10 lg:px-16 xl:px-24 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <span className="text-white text-[17px] font-semibold tracking-[-0.03em]">
              MotionX Studios
            </span>
            <p className="text-[13px] text-[#767d88] mt-2 leading-relaxed">
              100% AI-Native Production &amp; Hybrid Live-Action + AI VFX Studio.
            </p>
            <p className="text-[13px] text-[#767d88] mt-3">
              Hyderabad · US · UK · UAE · Bahrain
            </p>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.12em] text-white/50 mb-3">
              Verticals
            </p>
            <div className="flex flex-col gap-2 text-[13px]">
              <Link to="/ai-commercials-ugc" className="text-[#767d88] hover:text-white no-underline">
                AI Commercial Production
              </Link>
              <Link to="/ai-ugc-agency" className="text-[#767d88] hover:text-white no-underline">
                AI UGC Agency &amp; D2C Product Ads
              </Link>
              <Link to="/micro-drama-production" className="text-[#767d88] hover:text-white no-underline">
                9:16 Micro-Drama Production
              </Link>
              <Link to="/ai-vfx" className="text-[#767d88] hover:text-white no-underline">
                Feature Film Hybrid AI VFX
              </Link>
              <Link to="/ai-filmmaking" className="text-[#767d88] hover:text-white no-underline">
                AI Filmmaking &amp; Music Videos
              </Link>
              <Link to="/case-studies/stadium-vfx" className="text-[#767d88] hover:text-white no-underline">
                Stadium VFX Case Study
              </Link>
            </div>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.12em] text-white/50 mb-3">
              Contact
            </p>
            <div className="flex flex-col gap-2 text-[13px] text-[#767d88]">
              <a href="mailto:jagan@motionx.in" className="text-[#767d88] hover:text-white no-underline">
                jagan@motionx.in
              </a>
              <a href="tel:+919****7281" className="text-[#767d88] hover:text-white no-underline">
                +91-9003757281
              </a>
            </div>
          </div>

          <div>
            <p className="text-[11px] uppercase tracking-[0.12em] text-white/50 mb-3">
              Social
            </p>
            <div className="flex flex-col gap-2 text-[13px]">
              <a
                href="https://www.linkedin.com/company/motionx-studios"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#767d88] hover:text-white no-underline"
              >
                LinkedIn ↗
              </a>
              <a
                href="https://www.instagram.com/motionxstudio_/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#767d88] hover:text-white no-underline"
              >
                Instagram ↗
              </a>
              <a
                href="https://www.youtube.com/@motion-x-2025"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#767d88] hover:text-white no-underline"
              >
                YouTube ↗
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] text-[#767d88]">
          <span>&copy; 2026 MotionX Studios. All rights reserved.</span>
          <span>100% AI-Native Production &nbsp;·&nbsp; Hybrid Live-Action + AI VFX</span>
        </div>
      </div>
    </footer>
  );
}
